export default __webpack_public_path__ + "static/media/k10.2421a103.jpeg";